import { render, staticRenderFns } from "./history_turnover.vue?vue&type=template&id=c12b6b84&scoped=true&"
import script from "./history_turnover.vue?vue&type=script&lang=js&"
export * from "./history_turnover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c12b6b84",
  null
  
)

export default component.exports